import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import axios from "axios";
import { Button, Row, Col, Table } from "reactstrap";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoPendRecibir() {
  const { user } = useContext(AuthContext);
  const URL = `${process.env.REACT_APP_URL_ARTICULOS_RECEPCION_LAREDO}/PendRecibir`;

  const [articulos, setArticulos] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 100;

  const headers = [
    { name: "MLM",          field: "mlm",               sortable: true },
    { name: "Parent",       field: "codigo",             sortable: true },
    { name: "Nombre",       field: "nombre",             sortable: true },
    { name: "Proveedor",    field: "proveedor",          sortable: true },
    { name: "Factura",      field: "noFactura",          sortable: true },
    { name: "F. Recep.",    field: "fecha",              sortable: true },
    { name: "TC",           field: "tipoCambio",         sortable: true },
    { name: "Env USD",      field: "gastosEnvio",        sortable: true },
    { name: "Imp MXN",      field: "gastosImportacion",  sortable: true },
    { name: "En Bodega USA", field: "cantidad",           sortable: true },
    { name: "Enviado a Mx", field: "recibido",           sortable: true },
    { name: "Pend Recibir", field: "pendiente_recibir",  sortable: true },
    { name: "Precio USD",   field: "precio",             sortable: true },
    { name: "Acciones",     field: "",                   sortable: false },
  ];

  useEffect(() => {
    showLoader();
    axios.get(URL, { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } })
      .then(({ data }) => { setArticulos(data); hideLoader(); })
      .catch(err => { console.log(err); hideLoader(); });
  }, []);

  const commentsData = useMemo(() => {
    let filtered = articulos;
    if (search) {
      const s = search.toLowerCase();
      filtered = filtered.filter(a =>
        (a.mlm || "").toLowerCase().includes(s) ||
        (a.codigo || "").toLowerCase().includes(s) ||
        (a.nombre || "").toLowerCase().includes(s) ||
        (a.proveedor || "").toLowerCase().includes(s) ||
        (a.noFactura || "").toLowerCase().includes(s)
      );
    }
    setTotalItems(filtered.length);
    if (sorting.field) {
      filtered = [...filtered].sort((a, b) =>
        sorting.order === "asc"
          ? a[sorting.field] > b[sorting.field] ? 1 : -1
          : a[sorting.field] < b[sorting.field] ? 1 : -1
      );
    }
    return filtered.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  }, [articulos, search, sorting, currentPage]);

  const totalPend     = articulos.reduce((s, a) => s + (a.pendiente_recibir || 0), 0);
  const totalBodega   = articulos.reduce((s, a) => s + (a.cantidad || 0), 0);
  const totalEnviado  = articulos.reduce((s, a) => s + (a.recibido || 0), 0);

  return (
    <>
      <Header />
      <br /><br />
      {user.menu_compras ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <Row className="mb-2">
                  <Col md={12}>
                    <Button size="sm" color="danger" href="/BotonesCompras" id="botonListado">Regresar</Button>
                  </Col>
                </Row>

                <h5 style={{ fontWeight: 600 }}>Pendiente Recibir en México</h5>
                <p style={{ fontSize: "0.8rem", color: "#64748b" }}>
                  Artículos en Bodega USA pendientes de ser recibidos en almacén México — <strong>{new Intl.NumberFormat("en-US").format(totalPend)} pzas</strong>
                </p>

                <div className="row">
                  <div className="col-md-8">
                    <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage}
                      onPageChange={p => setCurrentPage(p)} />
                  </div>
                  <div className="col-md-4 d-flex flex-row-reverse">
                    <Search onSearch={v => { setSearch(v); setCurrentPage(1); }} />
                  </div>
                </div>

                <Table size="sm" bordered responsive striped>
                  <TableHeader headers={headers} onSorting={(f, o) => setSorting({ field: f, order: o })} />
                  <tbody>
                    {commentsData.map((a, i) => (
                      <tr key={i}>
                        <td>{a.mlm}</td>
                        <td>{a.codigo}</td>
                        <td>{a.nombre}</td>
                        <td>{a.proveedor}</td>
                        <td>{a.noFactura}</td>
                        <td>{a.fecha ? a.fecha.substring(0, 10) : ""}</td>
                        <td>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(a.tipoCambio)}</td>
                        <td>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(a.gastosEnvio)}</td>
                        <td>{new Intl.NumberFormat("en-US").format(a.gastosImportacion)}</td>
                        <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                        <td>{new Intl.NumberFormat("en-US").format(a.recibido)}</td>
                        <td><strong style={{ color: "#ef4444" }}>{new Intl.NumberFormat("en-US").format(a.pendiente_recibir)}</strong></td>
                        <td>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(a.precio)}</td>
                        <td>
                          <Button size="sm" color="success" href={`/ComprasCreate?rl=${a.idRecepcionLaredo}`}>
                            Crear Entrada
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ backgroundColor: "#f1f5f9", fontWeight: 700, color: "#1e293b" }}>
                      <td colSpan={9} className="text-end">TOTALES</td>
                      <td style={{ color: "#1e293b" }}>{new Intl.NumberFormat("en-US").format(totalBodega)}</td>
                      <td style={{ color: "#1e293b" }}>{new Intl.NumberFormat("en-US").format(totalEnviado)}</td>
                      <td style={{ color: "#ef4444" }}>{new Intl.NumberFormat("en-US").format(totalPend)}</td>
                      <td colSpan={2}></td>
                    </tr>
                  </tfoot>
                </Table>

                <Row>
                  <Col md={12}><p style={{ fontSize: "0.8rem", color: "#94a3b8" }}>{totalItems} artículos</p></Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      ) : <p className="text-muted ms-3">Sin acceso.</p>}
      {loader}
    </>
  );
}

export default ListadoPendRecibir;
